import React from "react";

export default function NoPost() {
  return (
    <h1 style={{ textAlign: "center", marginTop: "20px" }}>No Post to show</h1>
  );
}
